import React, {Component} from 'react';
import {Platform, StyleSheet, Text, View, ScrollView, TouchableOpacity} from 'react-native';


export default class HMSvgUri extends Component {

    render() {

        const {style, text, icon, navigateParams, typeIcon, uri, source} = this.props;
        return (
            <div
                style={{...style}}
            >
                <img

                    {...this.props}
                    // width="100" height="50"
                    // src={"https://dev.w3.org/SVG/tools/svgweb/samples/svg-files/410.svg"}
                    src={uri ? uri : source}
                    // src={logo}
                />
            </div>

        );
    }


}
